var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
  'checkbox': true,
  'custom-icon--tick': true,
  'checkbox--checked': _vm.value,
  'checkbox--indeterminate': _vm.indeterminate,
  'checkbox--enabled': _vm.enabled,
  'checkbox--disabled': !_vm.enabled,
},on:{"click":_vm.toggle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372798a3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckBox.vue
// module id = 727
// module chunks = 1